module.exports = __webpack_public_path__ + "img/netflix-new-icon.db05a551.png";